import React from 'react'

const HomePageText = () => {
  return (
    <div className="container my-4">
      <div className="card shadow p-4" style={{ borderRadius: '15px' }}>
        <h2 className="text-center mb-4" style={{ color: '#2c3e50' }}>
          Helping Aspirants Excel in the Final Stage of Civil Services Examination
        </h2>
        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
          The Personality Test or Interview stage of the UPSC Civil Services Examination is not just the final hurdle—
          it is the defining moment that can dramatically elevate your rank. At <strong>INSIGHT IAS</strong>, led by the
          highly respected <strong>S. Baliyan Sir</strong>, we specialize in helping aspirants unlock their full
          potential and perform with confidence, clarity, and conviction before the UPSC interview board.
        </p>
        <p>
          Most of the aspirants are theoretically excellent, but fail to get past in the oral rounds. This is not
          because they lack the desired charisma, but they do not know the exact approach. The aspirants, who have
          been successful, have some similar traits which have made them achieve great heights.
        </p>
        <p>
          Even though the interview carries 275 marks with no minimum qualifying marks, it is the deciding factor for
          most of the candidates. Your final selection may depend on just a few marks. The Interview can make or break
          you, so take your personality test seriously and attend mock interviews before the real one.
        </p>

        <h4 className="mt-4" style={{ color: '#2980b9' }}>Why Our Interview Guidance Program Stands Out</h4>
        <p>
          Every year, our students consistently secure high marks in the UPSC interview, with many scoring 200+, and
          several achieving ranks in the Top 10, Top 50, and Top 100. Our personalized mentorship and strategic
          training help candidates reflect the qualities UPSC looks for in a future civil servant.
        </p>

        <h5 className="mt-3" style={{ color: '#16a085' }}>Unique Features:</h5>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">One-on-One Mock Interviews with S. Baliyan Sir and panel of experts</li>
          <li className="list-group-item">Detailed Feedback & Personality Assessment</li>
          <li className="list-group-item">Customized DAF Analysis & Preparation</li>
          <li className="list-group-item">Confidence Building & Communication Training</li>
          <li className="list-group-item">Ethics, Opinions & Situational Judgment Practice</li>
          <li className="list-group-item">Current Affairs & Issue-Based Discussions tailored for interview</li>
        </ul>

        <h4 style={{ color: '#d35400' }}>The INSIGHT Advantage</h4>
        <p>
          With years of mentoring success, S. Baliyan Sir understands exactly what the UPSC board looks for—
          maturity of thought, ethical grounding, clarity in communication, and balanced perspectives. His deep
          understanding of psychology and methodical training has helped hundreds succeed in their interviews.
        </p>

        <h5 className="text-success">Success Speaks for Itself</h5>
        <p>
          Our alumni have entered the services with ranks as high as <strong>AIR 1, AIR 2, AIR 3</strong>, and many
          others in the top 50. Their interview scores were the game-changer that ensured their final selection.
        </p>
      </div>
    </div>
  )
}

export default HomePageText